<div fxLayout="column" class="container">
  <div fxLayout="column" fxLayoutAlign="space-around center">
    <form (ngSubmit)="onCreateGroup()" #userCreationForm="ngForm">
      <div class="form-group">
        <label for="name">Nom</label>
        <input type="text" class="form-control" id="name"
               required
               [(ngModel)]="model.name" name="name">

      </div>
      <button type="submit" class="btn btn-success">Submit</button>
      <button type="button" (click)="onNoClick()">Annuler</button>
    </form>

  </div>
</div>
